import React, { Component } from 'react';
import styled from 'styled-components';

import { formatAtributeName } from '../services/formatAtributeName';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 5px;

  > div {
    flex-basis: 50%;
    overflow: hidden !important;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
  }
`;

export class CheckboxGroup extends Component {
  render() {
    const { data, selected, handleToggle } = this.props;

    return (
      <Wrapper>
        {data.map((item, i) => (
          <div key={`key-${item}-${i}`}>
            <input
              checked={selected && selected.filter((i) => i.item === item)[0].checked}
              id={`${item}-${i}`}
              onChange={handleToggle}
              type="checkbox"
              value={item}
            />
            <label htmlFor={`${item}-${i}`}>
              {formatAtributeName(item)}
            </label>
          </div>
        ))}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CheckboxGroup.js